import React, { useState } from "react";
import * as OFMSUI from "react-bootstrap";
import HousingService from "../../../Services/HousingService";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
// import { useHistory } from "react-router";
import { Field, Form, FormikProvider, useFormik } from "formik";
import { store } from "../../../App";
import ShowAlert from "../../alert";
import * as Yup from "yup";
import moment from "moment-timezone";
import { FaFastBackward } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
function DistrictwiseTransfer() {

  const history = useHistory();

  const [distList, setDistList] = useState();
  const [EmpTypeList, setEmpTypeList] = useState();
  const [TransferDataEnable, setTransferDataEnable] = useState(false);
  const [TransferData, setTransferData] = useState([]);



  const formik = useFormik({
    initialValues: {
      emp_type: "",
      fromDistrict: "",

      updatedistricttranferdata: [
        {
          emp_id: "",
          fromDistrict: "",
          toDistrict: "",
          emp_type: "",
          remarks: "",
          tranferDate: ""
        }
      ]
    },

    validationSchema: Yup.object({
      emp_type: Yup.string().required(),
      fromDistrict: Yup.string().required()
    }),
    onSubmit: (values) => {
      // console.log("values", values);
      store.dispatch({ type: "SHOW_SPINNER" });
      HousingService.GetDistrictwiseTransferData(values).then((resp) => {
        setTransferData(resp.data);
        setTransferDataEnable(true);
        store.dispatch({ type: "HIDE_SPINNER" });
      });
    }
  });

  React.useEffect(() => {
    HousingService.CGG_District().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.code}>
              {item.name}
            </option>
          );
        });
        setDistList(options);
      }
    });
    HousingService.fetchEmptypeList().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.emptype_id}>
              {item.emptype_name}
            </option>
          );
        });

        setEmpTypeList(options);
      }
    });
  }, []);

  const [Multiple, setMultiple] = useState([]);

  const handleCheckBox = (e, i, item, emp_id) => {
    // console.log("e.target.checked=", e.target.checked);

    // console.log("value", i);
    if (
      formik?.values?.updatedistricttranferdata[i]?.toDistrict === undefined ||
      formik?.values?.updatedistricttranferdata[i]?.toDistrict === ""
    ) {
      ShowAlert("To District is Required", "warning").then(() =>
        formik.setFieldValue((e.target.checked = false))
      );
    } else if (
      formik?.values?.updatedistricttranferdata[i]?.remarks === undefined ||
      formik?.values?.updatedistricttranferdata[i]?.remarks === ""
    ) {
      ShowAlert("Reason is required", "warning").then(() =>
        formik.setFieldValue((e.target.checked = false))
      );
    } else if (
      formik?.values?.updatedistricttranferdata[i]?.tranferDate === undefined ||
      formik?.values?.updatedistricttranferdata[i]?.tranferDate === ""
    ) {
      ShowAlert("Transfered is Required", "warning").then(() =>
        formik.setFieldValue((e.target.checked = false))
      );
    } else {
      if (e.target.checked) {
        const existingItem = Multiple.find((item) => item.emp_id === emp_id);
        if (!existingItem) {
          setMultiple([
            ...Multiple,
            {
              emp_id: emp_id,
              fromDistrict: formik.values.fromDistrict,
              toDistrict:
                formik.values.updatedistricttranferdata[i]?.toDistrict,
              emp_type: item.emp_type,
              remarks: formik.values.updatedistricttranferdata[i]?.remarks,

              tranferDate: moment(
                formik.values.updatedistricttranferdata[i]?.tranferDate
              ).format("DD/MM/YYYY")
            }
          ]);
        }
      } else {
        setMultiple(Multiple.filter((item) => !(item.emp_id === emp_id)));
      }
    }
  };

  const handleUpdate = () => {
    // console.log("updatedistricttranferdata", Multiple);
    if (Multiple?.length === 0) {
      ShowAlert("Please check at least one employee record before updating.", "warning");
      return;
    }else {

      let param = {
        updatedistricttranferdata: Multiple
      };
      store.dispatch({ type: "SHOW_SPINNER" });
      HousingService.UpdateDistrictwiseTransferData(param).then((response) => {
        if (response.data.SCODE === "01") {
          ShowAlert(response.data.SDESC, "success").then(() => {
          window.location.reload();
          });
          let values = {
            fromDistrict: formik.values.fromDistrict,
            emp_type: formik.values.emp_type
          };
          HousingService.GetDistrictwiseTransferData(values).then((res) => {
            setTransferData(res.data);
            setTransferDataEnable(true);
          });
        }else{
          ShowAlert(response.data.SDESC, "error");
        }
        store.dispatch({ type: "HIDE_SPINNER" });
      });
    }
  };
  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container>
        <OFMSUI.Row>
          <OFMSUI.Col
            xs={12}
            sm={12}
            md={12}
            lg={11}
            xl={11}
            xxl={11}
            className="page-titlespacing"
          >
            <div className="inner-herbpage-service-title1">
              {" "}
              <h1>District Transfer</h1>{" "}
            </div>
          </OFMSUI.Col>
          <OFMSUI.Col
            xs={12}
            sm={12}
            md={1}
            lg={1}
            xl={1}
            xxl={1}
            className="page-titlespacing"
          >
            <button
              className="btn btn-primary btn-sm"
                style={{ textAlign: "right", float: "right", marginTop: "30px",backgroundColor: "#603913",borderColor: "#603913", color: "#fff"
              }}
              type="reset"
              onClick={() => history.goBack()}
            >
              <FaFastBackward /> &nbsp;Back
            </button>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <OFMSUI.Row>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={3}
                xl={3}
                xxl={3}
                className="mb-3"
              ></OFMSUI.Col>

              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={2}
                xl={2}
                xxl={2}
                className="mb-3"
              >
                <th>
                  <b>District name:</b>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                </th>
                <Field
                  component="select"
                  name="fromDistrict"
                  className={
                    formik.touched.fromDistrict && formik.errors.fromDistrict
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  onChange={(e) => formik.handleChange(e)}
                >
                  {formik.touched.fromDistrict && formik.errors.fromDistrict ? (
                    <div className="invalid-feedback">
                      {formik.errors.fromDistrict}
                    </div>
                  ) : null}
                  <option>--select--</option>
                  {distList}
                </Field>
              </OFMSUI.Col>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={2}
                xl={2}
                xxl={2}
                className="mb-3"
              >
                <label>
                  <b>Employee Type</b>
                </label>
                <span className="mandatory" style={{ color: "red" }}>
                  {" "}
                  *{" "}
                </span>
                <Field
                  component="select"
                  name="emp_type"
                  className={
                    formik.touched.emp_type && formik.errors.emp_type
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                >
                  <option value="select">---select---</option>
                  {EmpTypeList}
                </Field>
              </OFMSUI.Col>
              <OFMSUI.Col
                xs={12}
                sm={12}
                md={12}
                lg={3}
                xl={3}
                xxl={3}
                className=""
              >
                <button
                  type="submit"
                  className="btn btn-primary btn-sm"
                  style={{ marginLeft: "30px", marginTop: "30px",backgroundColor: "#603913",borderColor: "#603913", color: "#fff" }}
                >
                  Get Details
                </button>
              </OFMSUI.Col>
            </OFMSUI.Row>
          </Form>
          {TransferDataEnable && (
            <Form>
              <OFMSUI.Container>
                <OFMSUI.Row>
                  <OFMSUI.Table striped bordered hover id="my-table">
                    <thead
                      className="fw-bold"
                      style={{ position: "sticky", top: "0px" }}
                    >
                      <tr>
                        <td colSpan={7} style={{ textAlign: "center" }}>
                          EMPLOYEE DETAILS
                        </td>{" "}
                      </tr>

                      <tr className="table_countshead">
                        <th>Sl.No</th>
                        <th>Employee Name/ Father Name</th>
                        <th>Designation</th>
                        <th>To district </th>
                        <th>Reason</th>
                        <th>Transfer Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {TransferData.length === 0 ? (
                        <tr>
                          <td colSpan={10} style={{ textAlign: "center" }}>
                            No data available
                          </td>
                        </tr>
                      ) : (
                        TransferData.map((item, i) => (
                          <tr key={i}>
                            <td style={{ textAlign: "center", width: "60px" }}>
                              {i + 1}
                            </td>
                            <td>
                              {item.empname}/{item.fathername}
                            </td>

                            <td>{item.designation}</td>
                            <td>
                              <Field
                                as="select"
                                name={`updatedistricttranferdata[${i}].toDistrict`}
                                // id="ToDistrict-select"
                                className="form-control"
                                // disabled={
                                //   !selectedCheckbox.includes(item.emp_id)
                                // }
                              >
                                <option value="">--select--</option>
                                {distList}
                              </Field>
                            </td>

                            <td>
                              <Field
                                name={`updatedistricttranferdata[${i}].remarks`}
                                id="remarks-select"
                                className="form-control"
                                // disabled={
                                //   !selectedCheckbox.includes(item.emp_id)
                                // }
                              ></Field>
                            </td>
                            <td>
                              <Field
                                name={`updatedistricttranferdata[${i}].tranferDate`}
                                className={
                                  formik.touched.tranferDate &&
                                  formik.errors.tranferDate
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                type="date"
                                onChange={(e) => formik.handleChange(e)}
                                // disabled={
                                //   !selectedCheckbox.includes(item.emp_id)
                                // }
                              />
                            </td>
                            <td style={{ textAlign: "center", color: "green" }}>
                              <input
                                type="checkbox"
                                onChange={(e) => {
                                  handleCheckBox(e, i, item, item.emp_id);
                                }}
                                // checked={selectedCheckbox.includes(item.emp_id)}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </OFMSUI.Table>
                  <div style={{ textAlign: "center" }}>
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      style={{ fontSize: "12px" }}
                      onClick={() => {
                        handleUpdate();
                      }}
                    >
                      Update
                    </button>
                  </div>
                </OFMSUI.Row>
              </OFMSUI.Container>
            </Form>
          )}
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
}
export default DistrictwiseTransfer;
